import styled from 'styled-components';

export const FullWidthFormContainer = styled.form`
  width: 100%;
`;
